export default {
  422: 'La extension no es valida',
};
